var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.924,
    viewBox: "0 0 18 16.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11203",
    "data-name": "Group 11203",
    transform: "translate(-39.716 -43.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M55.63,66.01c-.1.158-.2.319-.3.477v5.969a.848.848,0,0,1-.939.952c-.148,0-.3.005-.449.005l-.7,0c-.112,0-.222,0-.332,0a3.489,3.489,0,0,0-2.006.623c-.424.289-.858.58-1.284.865l-.128.084c-.4.265-.9.6-1.363.919a.278.278,0,0,1-.411,0c-.434-.3-.878-.595-1.31-.883l-.015-.008c-.485-.324-.957-.641-1.414-.955a3.589,3.589,0,0,0-2.088-.646h-.061l-.837,0c-.225,0-.408,0-.58-.005a.828.828,0,0,1-.891-.914c-.005-1.843-.005-5.481,0-7.278V64.6c0-.7.311-1.016,1.006-1.019q1.367,0,2.732,0h8.422l.5-.8q-.773,0-1.542,0H44.26q-1.363,0-2.732,0a1.669,1.669,0,0,0-1.81,1.823l0,.327c0,1.889,0,5.627,0,7.567A1.617,1.617,0,0,0,41.4,74.213c.179.005.368.008.6.008l.835-.005.061,0a2.78,2.78,0,0,1,1.634.5c.46.317.939.636,1.4.947l.02.013c.431.291.881.59,1.315.888a1.084,1.084,0,0,0,1.322,0c.454-.312.917-.623,1.391-.937l.048-.036c.442-.294.891-.595,1.335-.9a2.729,2.729,0,0,1,1.56-.482c.11,0,.217,0,.327,0l.692,0c.156,0,.314,0,.467,0a1.608,1.608,0,0,0,1.708-1.452.352.352,0,0,0,.023-.128V65.193Z",
    transform: "translate(0 -16.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M66.693,81.6c-.161.255-.319.511-.477.766a.075.075,0,0,0-.01.02H58.046a.393.393,0,1,1,0-.786Z",
    transform: "translate(-15.259 -32.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M65.7,98.617l-.123.536-.059.25H58.046a.393.393,0,1,1,0-.786Z",
    transform: "translate(-15.259 -47.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M58.054,115.654h10.28a.393.393,0,0,1,0,.786H58.054a.393.393,0,0,1,0-.786Z",
    transform: "translate(-15.266 -61.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M119.017,52.818l-.191.3q-1.612,2.584-3.216,5.171a1.023,1.023,0,0,0-.121.283c-.174.736-.345,1.472-.512,2.2a.815.815,0,0,0-.026.233.287.287,0,0,0,.286.292.36.36,0,0,0,.15-.035,1.068,1.068,0,0,0,.2-.132l.321-.262q.579-.468,1.151-.942l.047-.041a2.031,2.031,0,0,0,.477-.5q1.1-1.763,2.185-3.516l1.11-1.785c.018-.021.029-.044.047-.068Zm-2.1,6.484c-.238.2-.48.395-.721.595-.053.044-.088.047-.136.015-.071-.05-.144-.091-.212-.138a.088.088,0,0,1-.032-.077c.08-.353.162-.7.244-1.051a.16.16,0,0,1,.012-.024c.315.2.624.395.948.595C116.987,59.244,116.952,59.273,116.914,59.3Z",
    transform: "translate(-64.002 -8.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M146.114,43.974q-.456-.29-.917-.57a.613.613,0,0,0-.85.252c-.1.158-.2.316-.3.473l-.081.128-.02.037-.01-.006.14.087.041.026,1.577.978.168.1.118-.187c.093-.148.185-.3.276-.446A.61.61,0,0,0,146.114,43.974Z",
    transform: "translate(-88.665 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.56e13751490d23ea51954eb485fd1d92.svg";
export { ForwardRef as ReactComponent };